import { render, staticRenderFns } from "./boundCard.vue?vue&type=template&id=16081b4a&scoped=true"
import script from "./boundCard.vue?vue&type=script&lang=js"
export * from "./boundCard.vue?vue&type=script&lang=js"
import style0 from "./boundCard.vue?vue&type=style&index=0&id=16081b4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16081b4a",
  null
  
)

export default component.exports